import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useScopeControlCounts } from '../../../hooks/analytics/useScopeReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/** `scope_control_delta` — period-over-period Δ in total controls in scope. */
export const ScopeControlDeltaCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopeControlCounts();

  return (
    <WidgetCard
      title="Control Count Δ"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load control count delta.'}
      isEmpty={!isLoading && !isError && !data}
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <StatCard
        title="Control Count vs. Prior Sweep"
        value={data?.total ?? 0}
        icon={<TrendingUp className="h-5 w-5" />}
        color="bg-purple-100 text-purple-600"
        delta={data?.delta ?? undefined}
        deltaSuffix=""
        deltaDigits={0}
        subtitle={data?.prev_total != null ? `was ${data.prev_total}` : 'no prior snapshot'}
      />
    </WidgetCard>
  );
};

export default ScopeControlDeltaCard;
